import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Mechanism } from './components/Mechanism';
import { ProductIntro } from './components/ProductIntro';
import { Mistakes } from './components/Mistakes';
import { Contents } from './components/Contents';
import { Audience } from './components/Audience';
import { Transformation } from './components/Transformation';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-amber-500/30 selection:text-amber-100" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Mechanism data-id="element-3" />
      <ProductIntro data-id="element-4" />
      <Mistakes data-id="element-5" />
      <Contents data-id="element-6" />
      <Audience data-id="element-7" />
      <Transformation data-id="element-8" />
      <Pricing data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}